<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input v-model="searchText" search placeholder="搜索母液..." @on-change="searchSemi" clearable icon="ios-search"
          style="width: 250px; margin-right: 15px"></Input>
        <Select placeholder="工厂筛选" v-model="selectedFactory" label-in-value multiple filterable
          @on-change="choseFactory" :loading="loadingFactory" style="width: 220px; margin-right: 12px">
          <Option v-for="item in factoryList" :value="item._id" :key="item._id">
            {{
              item.name
            }}
          </Option>
        </Select>
        <Select v-model="isShowInvalid" style="width: 130px; margin-right: auto" @on-change="changeInvalid">
          <Option v-for="item in showInvalidList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <span>共{{ totalCounts }}条</span>
        <Page :total="totalCounts" :page-size="limit" @on-change="loadSemiItem" show-total simple
          style="margin-right: 24px" />
        <Button type="primary" @click="openCreateSemiDrawer()">新增母液</Button>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="semiItemList" :height="tableHeight"></Table>
    </div>
    <CreateSemiItemDrawer ref="CreateSemiItemDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import CreateSemiItemDrawer from "./CreateSemiItemDrawer";
import _ from "lodash";

export default {
  name: "SemiItemPage",
  components: {
    CreateSemiItemDrawer,
  },
  data() {
    return {
      searchText: "",
      columns: [
        {
          title: "母液",
          key: "material",
          align: "left",
          width: 150,
          render: (h, params) => {
            if (
              this.user.superAdmin ||
              arrayIntersection(["allFactoryLeader"], this.user.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color: "#42b983",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.CreateSemiItemDrawer.openDrawer(params.row);
                      },
                    },
                  },
                  params.row.material.model
                ),
              ]);
            }
          },
        },
        {
          title: "工厂",
          key: "factory",
          align: "left",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.factory.name);
          },
        },
        {
          title: "发货工厂",
          key: "fromSemiItem",
          align: "left",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.fromSemiItem
                ? params.row.fromSemiItem.factory.name
                : ""
            );
          },
        },
        {
          title: "金蝶云代码",
          key: "JDItemCode",
          align: "left",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.JDItemCode);
          },
        },
        {
          title: "配方名称",
          key: "recipe",
          align: "left",
          width: 200,
          render: (h, params) => {
            return h(
              "div",
              params.row.prodRecipe
                ? "#" +
                params.row.prodRecipe.NoId +
                " - " +
                params.row.prodRecipe.name
                : ""
            );
          },
        },
        {
          title: "母液运费",
          key: "fromFactoryCost",
          align: "left",
          render: (h, params) => {
            return h("div", params.row.importSemiTransCost);
          },
        },
        {
          title: "是否被禁用",
          key: "invalid",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#ed4014",
                },
              },
              params.row.invalid ? "是" : ""
            );
          },
        },
      ],
      page: 0,
      filterQuery: {},
      selectedFactory: [],
      loadingFactory: false,
      limit: 15,
      tableHeight: 300,
      isShowInvalid: 'false',
      showInvalidList: [
        {
          value: 'false',
          label: '正常',
        },
        {
          value: 'true',
          label: '禁用',
        },
        {
          value: 'all',
          label: '全部',
        },
      ]
    };
  },
  computed: {
    ...mapState({
      semiItemList: (state) => state.semiItem.semiItemList,
      totalCounts: (state) => state.semiItem.totalCounts,
      factoryList: (state) => state.factory.factoryList,
      user: (state) => state.auth.currentUser,
    }),
  },
  mounted() {
    this.getFactorys();
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getSemiItem: "semiItem/getSemiItemAction",
      getFactorys: "factory/getFactorysAction",
    }),
    searchSemi: _.debounce(function () {
      this.page = 0;
      this.loadSemiItem();
    }, 1000),
    async loadSemiItem(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.semi_name = this.searchText;
      } else {
        delete this.filterQuery.semi_name;
      }
      switch (this.isShowInvalid) {
        case 'false':
          this.filterQuery.invalid = false
          break;
        case 'true':
          this.filterQuery.invalid = true
          break;
        case 'all':
          delete this.filterQuery.invalid
          break;
      }
      try {
        this.tableLoading = true;
        await this.getSemiItem(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    choseFactory(e) {
      if (e.length > 0) {
        const factory = e.map((x) => x.value).join(",");
        this.filterQuery.factory = factory;
      } else {
        delete this.filterQuery.factory;
      }
      this.loadSemiItem();
    },
    changeInvalid() {
      this.loadSemiItem();
    },
    openCreateSemiDrawer() {
      this.$refs.CreateSemiItemDrawer.openDrawer();
    },
  },
  created() {
    this.loadSemiItem();
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between
.handle-right
  display flex
  justify-content space-between
  
.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>